import factory from '../../../store/factory'

export default {
  employees: factory('Employees'),
  employeenotes: factory('EmployeeNotes'),
  employee_documents: factory('EmployeeDocument'),
  employee_email_log: factory('EmployeeEmailLog'),
  fee_schedule: factory('FeeSchedule'),
  fee_plan: factory('FeePlan'),
}